import { css, type Theme } from '@emotion/react';
import { layoutStyles, mediaQuery, sideWidth, gutterWidth, mainWidth } from '../../Theme';

export interface SidebarProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {}

export const Sidebar = ({ children, ...props }: SidebarProps) => {
  return (
    <aside css={sidebarStyle} {...props}>
      {children}
    </aside>
  );
};

export interface ContentProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {}

export const Content = ({ children, ...props }: ContentProps) => {
  return (
    <section css={contentStyle} {...props}>
      {children}
    </section>
  );
};

export interface DashboardProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {}

export const Dashboard = ({ children, ...props }: DashboardProps) => {
  return (
    <article css={containerStyle} {...props}>
      {children}
    </article>
  );
};

const containerStyle = css`
  display: flex;
  flex-direction: column;
  ${layoutStyles}
  padding: 0 16px;
  padding-top: 32px;
  margin-bottom: 2rem;

  ${mediaQuery.medium(css`
    margin-bottom: 4rem;
    padding-left: 0;
    padding-right: 0;
    max-width: ${mainWidth}ch;
  `)}

  ${mediaQuery.large(css`
    flex-direction: row;
    padding-top: 48px;
    ${layoutStyles}
    margin-bottom: 4rem;
  `)}
`;

const sidebarStyle = css`
  ${mediaQuery.large(css`
    margin-left: ${gutterWidth}ch;
    width: ${sideWidth}ch;
  `)}
`;

const contentStyle = (theme: Theme) => css`
  margin-bottom: 2rem;

  .MuiFormControl-root {
    margin-bottom: 1rem;
  }

  > hr {
    margin: 2rem 0;
    height: 2px;
    background-color: ${theme.color.grey[60]};
    border: none;
  }

  ${mediaQuery.large(css`
    margin-bottom: 0;
    width: ${mainWidth}ch;
  `)}
`;
